<script>
import { courseComputed, courseListMethod } from '@state/helpers'
import accordion from '@components/accordian'
export default {
  components: {
    accordion: accordion,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
    tableName: {
      type: String,
      required: true,
      default: '',
    },
  },
  computed: {
    ...courseComputed,
  },
  created() {
    if (this.tableName === 'course') {
      this.getSessionByCourseId(this.data.item._id)
    }
  },
  methods: {
    ...courseListMethod,
    getSessionByCourseId(courseId) {
      const filter = {
        filter: courseId,
        fields: 'course_id',
        page: 1,
        limit: 10,
        sort: 'name',
        order: '1',
      }
      this.fetchCourseBatchList({ filter })
    },
    prepareData(data) {
      var finaldata = []
      data.forEach((element) => {
        element.active = false
        finaldata.push(element)
      })

      return finaldata
    }
    
  },
}
</script>
<template>
  <b-card>
    <b-row  v-if="tableName === 'course'">
      <accordion
        v-if="courseSessionList.docs"
        id="accord"
        :content="prepareData(courseSessionList.docs)"
      ></accordion>
      <b-col v-else>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="pl-2"></strong>
        </div>
      </b-col>
    </b-row>
    <b-row  v-if="tableName === 'QUESTION'">
      <b-col>
        <div v-for="(item, index) in prepareData(data.item.question)" :key="index" class="my-2">
          <strong class="pl-2">Q. {{item.question}}</strong>
          <p class="pl-2">A. {{item.answer}}</p>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>
